<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-info py-lg-5 py-1 pt-lg-4 pt-6">
      <div class="container text-center">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <img :src="companyLogo !== '' ? companyLogo : '/img/avatars/user-avatar.png'" class="login-user" />
              <h1 class="text-white pt-2">{{ companyName }} Login</h1>
            </div>
          </div>
        </div>
      </div>

      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <b-modal :header-text-variant="''" :id="`twoFactorModal`" title="SMS Authentication Required" class="text-gray" centered hide-footer>
      <div style="display: flex; flex-direction: column; gap: 1.5rem">
        <div>Your 6-digit OTP has been sent to your mobile phone. Please enter it below to continue.</div>
        <base-input
          id="otp"
          v-model.trim="account['otp']"
          v-validate="'required|numeric|min:6|max:6'"
          name="OTP"
          class="mb-3"
          prepend-icon="fas fa-key"
          type="text"
          placeholder="Enter your OTP"
          :error="getError('otp')"
          :class="{ input: true, 'is-invalid': errors.has('otp') }">
        </base-input>
        <div :style="{ display: 'flex', gap: '1rem', justifyContent: 'space-around' }">
          <button :style="{ width: '40%', maxWidth: '250px' }" class="btn btn-outline-primary mb-3 mb-md-0" @click="click2faResend">Resend OTP</button>
          <button type="submit" @click="click2faProceed" :style="{ width: '40%', maxWidth: '250px' }" class="btn btn-primary mb-3 mb-md-0">Proceed</button>
        </div>
      </div>
    </b-modal>
    <!-- Page content -->
    <div class="container container mt-lg--8 mt--6">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0 p-3">
            <div class="card-body">
              <!--<p v-show="hasError" :class="{'is-invalid':hasError}" class="form-feedback">{{error | capitalizeWords}}</p>-->
              <form v-promise-btn="{ action: 'submit' }" role="form" @submit.prevent="login">
                <base-input
                  id="email"
                  v-model.trim="account['email']"
                  v-validate="'required|email'"
                  name="email"
                  class="mb-3"
                  prepend-icon="fas fa-envelope"
                  type="email"
                  placeholder="Enter your email"
                  :error="getError('email')"
                  :class="{ input: true, 'is-invalid': errors.has('email') }">
                </base-input>

                <base-input
                  id="password"
                  v-model.trim="account['password']"
                  v-validate="'required'"
                  name="password"
                  class="mb-3"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Enter your password"
                  :error="getError('password')"
                  data-vv-delay="1000"
                  :class="{ input: true, 'is-invalid': errors.has('password') }">
                </base-input>
                <div class="row mt-3">
                  <div class="col-6">
                    <router-link to="/password/reset/admin" class="text-gray-200"><small>Forgot password?</small></router-link>
                  </div>
                  <div class="col-6 text-right">
                    <button type="submit" name="submit" class="btn primary btn-submit btn-vobo padded" size="vobo">Sign in</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer-main" class="container py-5">
      <div class="row align-items-center justify-content-xl-between">
        <div class="col-xl-6"></div>
        <div class="col-xl-6">
          <div v-if="companyCopyright == ''" class="copyright text-center text-xl-right text-right text-muted">
            © {{ year }} <a href="http://www.vobo.com/">VOBO</a>, LLC
          </div>
          <div v-else class="copyright text-center text-xl-right text-right text-muted" v-html="companyCopyright"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { resendOtp } from '@/api/request/user';
import { parseAutoLoginToken } from '@/utils/crypto';
import * as Cookie from 'js-cookie';
import config from 'config';
import { wrapNotification } from '@/utils/notification';
import { decoder } from '@/utils/sessions/jwt';
Vue.use(Cookie);

export default {
  name: 'Login',
  data() {
    return {
      companyID: '',
      companyName: '',
      companyLogo: '',
      companyCopyright: '',
      account: {
        email: '',
        password: '',
        otp: '',
      },
      error: '',
      hasError: false,
      year: new Date().getFullYear(),
    };
  },
  watch: {
    account: {
      handler: function (after, before) {
        this.hasError = false;
      },
      deep: true,
    },
  },
  mounted() {
    const companyID = this.$route.params.companyID;
    this.getCompanyInfo(companyID);

    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'twoFactorModal') {
        this.account.otp = '';
      }
    });

    if (this.$router.currentRoute.query.autoLogin) {
      const query = this.$router.currentRoute.query;
      const autoLogin = query.autoLogin;
      const redirect = query.redirect;

      const { isValid, payload } = parseAutoLoginToken(autoLogin);
      if (!isValid) {
        this.notifyVue('danger', 'Invalid authentication token');
        this.error = error.errMessage;
        this.hasError = true;
        return;
      }

      this.account.email = payload.email || '';
      this.account.password = 'password'; // dummy to pass validator

      return this.$store
        .dispatch('auth/AUTH_REQUEST', { autoLogin })
        .then((res) => {
          const decode = decoder({ secret: config.secret });
          var payload = decode(res.token);

          Cookie.set('user-token', res.token);
          Cookie.set('menuColor', payload.menuColor || '');
          Cookie.set('brandUrl', payload.brandUrl || '');
          Cookie.set('adminColor', payload.adminColor || '');
          Cookie.set('companyID', payload.companyID || '');
          Cookie.set('companyName', payload.clientName || '');
          Cookie.set('companyLogo', payload.favicon || '');
          Cookie.set('providerID', payload.providerID || '');
          Cookie.set('role', payload.role || '');
          Cookie.set('userGroup', payload.userGroup || '');
          Cookie.set('isPrimary', payload.isPrimary || '');
          Cookie.set('isFirstTimeLogin', payload.isFirstTimeLogin || '');
          Cookie.set('email', payload.email || '');
          Cookie.set('exp', payload.exp || '');

          if (this.$store.getters['auth/isAuthenticated']) {
            if (redirect) {
              const redirectUrl = new URL(redirect, window.location.origin);
              this.$router.push(redirectUrl.pathname + redirectUrl.search);
            } else {
              this.$router.push('/');
            }
          } else {
            wrapNotification(this.$notify, 'danger', 'You are not authorized to access this page.');
            this.$router.push('/login');
          }
        })
        .catch((error) => {
          error.then((error) => {
            console.error('login error', error);

            if (error && typeof error === 'object' && 'errMessage' in error && error.errMessage === 'Invalid OTP') {
              if (this.account.otp !== '') {
                this.account.otp = '';
                this.notifyVue('danger', this.$options.filters.capitalizeWords(error.errMessage));
              }
              this.$bvModal.show('twoFactorModal');
            } else {
              if (error && typeof error === 'object' && 'errMessage' in error) {
                this.notifyVue('danger', this.$options.filters.capitalizeWords(error.errMessage));
                this.error = error.errMessage;
                this.hasError = true;
              }
            }
          });
        });
    }
  },
  methods: {
    click2faResend() {
      this.account.otp = '';
      resendOtp(this.account.email)
        .then(() => {
          this.notifyVue('info', 'OTP has been resent to your mobile phone.');
        })
        .catch((err) => {
          console.error(err);
          this.notifyVue('danger', 'Failed to resend OTP.');
        });
    },
    click2faProceed() {
      this.$validator.validate('OTP').then((isValid) => {
        if (!isValid) {
          this.notifyVue('danger', 'Please enter a valid OTP.');
          return;
        }
        this.$bvModal.hide('twoFactorModal');
        this.login();
      });
    },
    getCompanyInfo(companyID) {
      companyID = companyID !== 'login' ? companyID : null;

      if (companyID) {
        this.$store
          .dispatch('company/GET_COMPANY_BY_COMPANY_ID', companyID)
          .then((resp) => {
            this.companyID = resp.data.companyID;
            this.companyName = resp.data.name;
            this.companyLogo = resp.data.logo;

            var faviconIcon = resp.data.favicon + '?=' + Math.random() || '/favicon.ico';
            var favicon = document.querySelectorAll('.favicon');
            for (var i = 0; i < favicon.length; i++) {
              favicon[i].href = faviconIcon;
            }
            document.title = resp.data.name;

            var copyright = resp.data.copyright;

            if (copyright && copyright.value) {
              this.companyCopyright = copyright.message;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        var favicon = document.querySelectorAll('.favicon');
        for (var i = 0; i < favicon.length; i++) {
          favicon[i].href = '/favicon.ico';
        }

        document.title = 'Vobo';
      }
    },
    getError(name) {
      return this.errors.first(name);
    },
    login: function () {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          let promiseButton = document.querySelector('.promise-btn__spinner-wrapper');
          promiseButton.classList.remove('hidden');
          const { email, password, otp } = this.account;
          const query = this.$router.currentRoute.query;
          const redirect = query.redirect;
          return this.$store
            .dispatch('auth/AUTH_REQUEST', {
              email,
              password,
              otp,
            })
            .then((res) => {
              const decode = decoder({ secret: config.secret });
              var payload = decode(res.token);

              Cookie.set('user-token', res.token);
              Cookie.set('menuColor', payload.menuColor || '');
              Cookie.set('brandUrl', payload.brandUrl || '');
              Cookie.set('adminColor', payload.adminColor || '');
              Cookie.set('companyID', payload.companyID || '');
              Cookie.set('companyName', payload.clientName || '');
              Cookie.set('companyLogo', payload.favicon || '');
              Cookie.set('providerID', payload.providerID || '');
              Cookie.set('role', payload.role || '');
              Cookie.set('userGroup', payload.userGroup || '');
              Cookie.set('isPrimary', payload.isPrimary || '');
              Cookie.set('isFirstTimeLogin', payload.isFirstTimeLogin || '');
              Cookie.set('email', payload.email || '');
              Cookie.set('exp', payload.exp || '');
              if (this.$store.getters['auth/isAuthenticated']) {
                if (redirect) {
                  const redirectUrl = new URL(redirect, window.location.origin);
                  this.$router.push(redirectUrl.pathname + redirectUrl.search);
                } else {
                  this.$router.push('/');
                }
              }
              promiseButton.classList.add('hidden');
            })
            .catch((err) => {
              if (this.$store.state.auth.hasOwnProperty('userEmail') && this.$store.state.auth.userEmail !== '') {
                this.$router.push({ path: '/verify' });
              } else {
                promiseButton.classList.add('hidden');
                err.then((error) => {
                  if (error && typeof error === 'object' && 'errMessage' in error) {
                    if (error.errMessage === 'Invalid OTP' && this.account.otp !== '') {
                      this.account.otp = '';
                      this.notifyVue('danger', this.$options.filters.capitalizeWords(error.errMessage));
                      this.$bvModal.show('twoFactorModal');
                    } else if (error.errMessage === 'Invalid OTP') {
                      this.$bvModal.show('twoFactorModal');
                    } else {
                      this.notifyVue('danger', this.$options.filters.capitalizeWords(error.errMessage));
                      this.error = error.errMessage;
                      this.hasError = true;
                    }
                  }
                });
              }
            });
        }
      });
    },
    notifyVue(type = 'default', message) {
      this.$notify({
        message: message,
        timeout: 4000,
        icon: 'fas fa-exclamation-triangle',
        type,
      });
    },
  },
};
</script>
<style lang="scss">
.modal-title {
  color: #32325d !important;
}
</style>
